//
import { combineActions, handleActions } from 'redux-actions';

import { resourceUndoUpserters, resourceUpserters } from 'app-components/flux/core';

import * as actions from './actions';
import { mkVehiclesStore } from './types';

const vehiclesReducer = handleActions(
  {
    // [actions.createVehicle]: (state) => state.set( 'isLoading', true),
    // [actions.createVehicle]:
    //   (state, { payload: vehicle }) => upsertResource(state, vehicle),

    [actions.createVehicle]: (state) => state.set('isLoading', true),
    [actions.createVehicleSuccess]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.deleteVehicle),

    [actions.updateVehicle]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.updateVehicle),
    [actions.updateVehicleSuccess]: (state, { payload: vehicle }) => resourceUpserters.upsertResource(state, vehicle),

    [actions.deleteVehicle]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.createVehicle),
    [actions.deleteVehicleSuccess]: (state, { payload: vehicle }) => resourceUpserters.upsertResource(state, vehicle),

    [actions.getVehicles]: (state) => state.set('isLoading', true),
    [actions.getVehiclesSuccess]: (state, { payload: data }) => resourceUpserters.upsertResources(state, data),
    [actions.getVehiclesFailure]: (state, { payload: error }) => resourceUpserters.completeWithError(state, error),

    [combineActions(actions.createVehicleFailure, actions.updateVehicleFailure, actions.deleteVehicleFailure)]: (
      state,
      { payload: error, asyncDispatch },
    ) => {
      asyncDispatch(actions.getVehicles());
      return resourceUpserters.resetResources(state, error);
    },
  },
  mkVehiclesStore(),
);

export const REDUCER_KEY = 'vehiclesStore';
export default vehiclesReducer;
